import AuthenticationService from '@/services/authentication';
import store from '@/store';

// URLs que não devem ser validadas para refresh token
const EXCLUDED_URLS = [
  '/autenticacao',
  '/autenticacao/refresh-token',
  '/autenticacao/refresh-token/revogar',
  '/autenticacao/novoToken',
  '/autenticacao/externa/url',
  '/autenticacao/externa',
  '/parametroSistema',
];

function isRefreshTokenValid() {
  const userState = store.state && store.state.User;
  const refreshTokenExpiration = userState && userState.refreshTokenExpiration;

  if (!refreshTokenExpiration) {
    return false;
  }

  const expirationDate = new Date(refreshTokenExpiration);
  return Date.now() < expirationDate.getTime();
}

/**
 * Verifica se a URL da requisição deve ser excluída da validação do refresh token.
 * @param {string} url URL da requisição.
 * @returns {boolean} True se deve ser excluída da validação.
 */
export function shouldSkipValidation(url) {
  return EXCLUDED_URLS.some(excludedUrl => url?.includes(excludedUrl));
}

/**
 * Interceptor que verifica se o refresh token ainda é válido antes de fazer
 * requisições autenticadas. Se o refresh token estiver expirado, redireciona
 * automaticamente para o login.
 * @param {Object} config Configuração da requisição do axios.
 * @returns {Object} Configuração da requisição (se válida) ou rejeição da promise.
 */
export default function refreshTokenValidationInterceptor(config) {
  // Pula validação para rotas de autenticação
  if (shouldSkipValidation(config.url)) {
    return config;
  }

  // Só valida para requisições autenticadas
  if (!store.getters.authenticated) {
    return config;
  }

  const refreshTokenExistsAndNotExpired = isRefreshTokenValid();

  if (!refreshTokenExistsAndNotExpired) {
    store.dispatch('setRefreshTokenExpired', true);

    setTimeout(() => {
      AuthenticationService.redirectToLogin(true);
    }, 0);

    return Promise.reject(new Error('Refresh token expired'));
  }

  return config;
}
